import { useState } from "react"
import "./headerCvTwo.scss"
import ThemeCvDto from "../../../../../api/models/cvTheme"
import UserDto from "../../../../../api/models/user"

interface HeaderCvTwoProps {
	theme?: ThemeCvDto | null
	user: UserDto
	isPhoto?: boolean
	photoUrl: string | null
}

function HeaderCvTwo({ theme, user, isPhoto, photoUrl }: HeaderCvTwoProps) {
	const [text, setText] = useState("")

	const calculeAge = (dateValue: string | Date): number => {
		const birthDate =
			dateValue instanceof Date ? dateValue : new Date(dateValue)
		const today = new Date()

		let age = today.getFullYear() - birthDate.getFullYear()
		const monthDifference = today.getMonth() - birthDate.getMonth()

		if (
			monthDifference < 0 ||
			(monthDifference === 0 && today.getDate() < birthDate.getDate())
		) {
			age -= 1
		}

		return age
	}

	const formatDateFrench = (dateValue: string | Date) => {
		const date = dateValue instanceof Date ? dateValue : new Date(dateValue)
		return new Intl.DateTimeFormat("fr-FR", {
			day: "numeric",
			month: "long",
			year: "numeric",
		}).format(date)
	}

	return (
		<div className="header-two">
			<div
				className="header-two-bg"
				style={{
					backgroundImage: `url("${theme?.imagePrincipale}")`,
				}}
			/>

			<div className="header-two-content">
				<div className="lastname-two">{user.name}</div>
				<div className="lastname-two">{user.firstName}</div>
				{user.dateOfBirth && (
					<div className="info-two">
						{calculeAge(user.dateOfBirth)} ans
					</div>
				)}
				<div className="info-two">{user.phone}</div>
				<div className="info-two email-two">{user.email}</div>
				{user.diploma && <div className="info-two">{user.diploma}</div>}

				<textarea
					className={
						text.trim() === ""
							? "styleTextArea-1-two empty-for-print"
							: "styleTextArea-1-two filled-for-print"
					}
					value={text}
					onChange={e => setText(e.target.value)}
					placeholder="Exprimez vous...!"
				/>

				<div className="description-two">
					{user.searchSubject === "INTERNSHIP_SUBJECT" ||
					user.searchSubject === "WORK_STUDY_SUBJECT" ? (
						<>
							Recherche de{" "}
							{user.searchSubject === "INTERNSHIP_SUBJECT"
								? "stage"
								: "alternance"}{" "}
							{user.internshipPeriod}
						</>
					) : null}
					{user.internshipStartDate && user.internshipEndDate ? (
						<span>
							{" "}
							du {formatDateFrench(
								user.internshipStartDate,
							)} au {formatDateFrench(user.internshipEndDate)}
						</span>
					) : null}
				</div>

				{isPhoto && photoUrl && (
					// eslint-disable-next-line jsx-a11y/img-redundant-alt
					<img
						src={photoUrl}
						alt="Photo de profil"
						className="img-profil2-two"
					/>
				)}
			</div>
		</div>
	)
}

export default HeaderCvTwo
